"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cross_fetch_1 = require("cross-fetch");
var query_string_1 = __importDefault(require("query-string"));
var createFetchWithTimeout = function (timeoutInMillis, fetchFn) { return function (input, init) {
    var timeout;
    return Promise.race([
        fetchFn(input, init),
        new Promise(function (res) {
            timeout = setTimeout(function () { return res(new cross_fetch_1.Response(null, { status: 408 })); }, timeoutInMillis);
        }),
    ])
        .then(function (response) {
        if (timeout) {
            clearTimeout(timeout);
        }
        return response;
    })
        .catch(function (error) {
        if (timeout) {
            clearTimeout(timeout);
        }
        throw error;
    });
}; };
exports.createFetchClient = function (_a) {
    var _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.fetch : _b, getAuthenticationToken = _a.getAuthenticationToken, clientId = _a.clientId, clientSecret = _a.clientSecret, _c = _a.requestTimeoutInMillis, requestTimeoutInMillis = _c === void 0 ? 8000 : _c, onError = _a.onError;
    var fetchClient = function (input, init) {
        if (init === void 0) { init = {}; }
        var headersPromise;
        if (getAuthenticationToken) {
            headersPromise = Promise.resolve(getAuthenticationToken()).then(function (t) { return ({ Authorization: "Bearer " + t }); });
        }
        else if (clientId && clientSecret) {
            headersPromise = Promise.resolve({ 'X-Client-Id': clientId, 'X-Client-Secret': clientSecret });
        }
        else {
            headersPromise = Promise.resolve({});
        }
        var fetchPromise = headersPromise.then(function (authHeaders) {
            return fetch(input, __assign({}, init, { headers: __assign({}, init.headers, authHeaders) }));
        });
        if (onError) {
            fetchPromise = fetchPromise.then(function (response) {
                if (!response.ok) {
                    setImmediate(function () { return onError(response); });
                }
                return response;
            });
        }
        return fetchPromise;
    };
    if (!requestTimeoutInMillis) {
        return fetchClient;
    }
    return createFetchWithTimeout(requestTimeoutInMillis, fetchClient);
};
function delay(timeout) {
    return new Promise(function (resolve) { return setTimeout(resolve, timeout); });
}
exports.delay = delay;
exports.isScanKey = function (key) { return key === '_' || key.endsWith('/_'); };
exports.optimizeInclude = function (keys) {
    var count = 0, i = 0;
    var keysLength = keys.length;
    var result = new Array(keysLength);
    keys = keys.map(exports.normalizeKeyPath).sort();
    var handleKey = function (key) {
        result[count] = key;
        count++;
        if (!exports.isScanKey(key)) {
            return;
        }
        var prefixLength = key.length - 1;
        var prefix = key.substring(0, prefixLength);
        while (i < keysLength) {
            var nextKey = keys[i];
            if (!nextKey.startsWith(prefix)) {
                break;
            }
            i++;
            if (nextKey.includes('/@', prefixLength)) {
                handleKey(nextKey);
            }
        }
    };
    while (i < keysLength) {
        var key = keys[i];
        i++;
        handleKey(key);
    }
    result.splice(count);
    return result;
};
exports.normalizeBaseUrl = function (url) {
    return url.endsWith('/') ? url.substr(0, url.length - 1) : url;
};
exports.normalizeKeyPath = function (keyPath) {
    return keyPath.startsWith('/') ? keyPath.substr(1) : keyPath;
};
exports.toQueryString = function (query) {
    var queryString = query_string_1.default.stringify(query);
    return queryString ? "?" + queryString : '';
};
function deprecated(newMethod) {
    var notified = false;
    return function (target, propertyKey, descriptor) {
        var originalValue = descriptor.value;
        descriptor.value = function () {
            if (!notified) {
                if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
                    var name_1 = target.constructor.name;
                    console.warn("the " + name_1 + "." + propertyKey + " method is deprecated, please use " + name_1 + "." + newMethod + " instead");
                }
                notified = true;
            }
            return originalValue.apply(this, arguments);
        };
    };
}
exports.deprecated = deprecated;
//# sourceMappingURL=utils.js.map